import React, { Component, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, QuickUploader, Action, AlertD, ModalCustom, ActionButton, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState, Paging } from '../.././Componet';
import { useParams } from "react-router-dom";
import { Route, Link } from "react-router-dom";
import { Modal } from 'bootstrap';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'
import { data } from 'jquery';


function SendMessage(props) {

    const submit = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        var model = h.GetPostData();
        var data = new FormData();
        data.append('title', model.Title);
        data.append('context', model.Context);
        var users = $('#txtuser').val();
        for (let i = 0; i < users.length; i++) {
            data.append('Users', users[i]);
        }
        var files = document.getElementById('txtFiles').files;
        for (let i = 0; i < files.length; i++) {
            data.append('Files', files[i], files[i].name)
        }

        h.AjaxForUpload('InBox', 'Send', data, (data) => {
            h.Alert(data.message);
            if (data.status == '200') {
                h.GoBack();
            }


        });

    };
    const loadMessage = (id)=>
    {
        let h = new Helper();
        h.Ajax('InBox', 'Get', { id: id },
            (data) => {
                $('#txtTitle').val('پاسخ به ' + data.title);
                setTimeout(() => { window.tinymce.editors['txtContext'].setContent('پیغام مورخه ' + data.createTime + "<br/>" + data.context) }, 500);
                h.Select2AjaxSelectOption(data.userName, document.getElementById('txtuser'), h);
                setTimeout(() => {
                    $('#txtuser').val([data.userName]).trigger('change');
                    
                },1500);
            }
    
        )
    };
    let id = useParams().id;
    if (id != undefined) {
        loadMessage(id);
    }


    return <FromSubmit submitBev={submit} staticTitle="پیام جدید">
       <InputBox meta={DataClass.PanelMessage.Title} size="100%" />
       <DropDownBox multi={true} caption="گیرندگان" columnName="user" size="100%" mustFill={"yes"} entity="targetUser" />

        <InputBox meta={DataClass.PanelMessage.Context} size="100%" customHelper={CustomHelper.Html} />
       <FormDiv size="100%">
           ضمیمه  :<input type="file" id="txtFiles" multiple />

       </FormDiv>    
    </FromSubmit>

}
const listType = { inbox: 0, outbox: 1 };
function MessageList(props= { type: listType.inbox }) {

    
    const [pageState, loadState] = useState({ data: null });
    const serach = (pageNumber) => {
        let h = new Helper();
       var obj=  h.GetPostData();
        obj.pageNumber = pageNumber;
        if (obj.targetUser == '*') {
            obj.targetUser = null;
        }
        h.Ajax('Inbox', props.type == listType.inbox ? 'inbox' : 'outbox',
           obj , (result) => {
                loadState({ data: result });
            }

        )


    };
    const loadUnReaded = (pageNumber) => {
        let h = new Helper();
         
        h.Ajax('Inbox','UnReaded',
            {} , (result) => {
                loadState({ data: result });
            }

        )


    };
    if (props.unread != undefined) {
        if (pageState.data == null) {
            loadUnReaded();
        }
       
    }
    return <FromBasic>
        <InputTextBox columnName="start" size="50%" customHelper={CustomHelper.isDate} model="start" caption="از تاریخ"></InputTextBox>
        <InputTextBox columnName="to" size="50%" customHelper={CustomHelper.isDate} model="end" caption="تا تاریخ"></InputTextBox>
        <DropDownBox   caption={props.type == listType.inbox ?"فرستده":"گیرنده"} columnName="targetUser" size="50%" mustFill={"yes"} entity="targetUser" />
        <InputTextBox size="50%" columnName="title"   model="title" caption="عنوان"></InputTextBox>
        <center>
            <SimpleButton title="جست و جو" onClick={()=>serach(1) }></SimpleButton>
        </center>
        {pageState.data != null
            &&
            <div>
            <ProTable datasourcename="messages" rowNumbering={true} rowFormating={
                (r) => {
                    if (r.readed == false) {
                        return "bgOrange";
                    }
                }} Records={pageState.data.messages} >
                <Column caption="از" columnName="sender" type={ColumnType.DisplayValue} />
                <Column caption="به" columnName="revicer" type={ColumnType.DisplayValue} />
                <Column caption="عنوان" columnName="title" type={ColumnType.DisplayValue} />
                    <Column caption="زمان ارسال" columnName="sendTime" type={ColumnType.DisplayValue} />
                    <Action type="Link" pageName="/Message" columnName="id" caption="مشاهده" />
                    
                </ProTable>
                <Paging targetFun={serach} totalPage={pageState.data.totalPage} currentPage={pageState.data.currentPage}></Paging>
            </div>
        }
    </FromBasic>
}

function ReadMessage(props) {
    let id = useParams().id;
    const [pageState, loadState] = useState({ data: null });

    const load = () => {
        let h = new Helper();
        h.Ajax('Inbox', 'Read', { 'id': id },
            (result) => {
                loadState({ data: result });
            }
        );

    };


    if (pageState.data == null) {
        load();
        return <LoadingBar />
    }
    return <FromBasic>
        <FormDiv size="100%">
        از :{pageState.data.userName}<br />
            به :{pageState.data.messageRecivers.map((v) => {
                return <text style={{ padding:'5px' }}>{v.userTitle}
                ({v.readTime == null ? "خوانده نشده" : v.readTime})
            </text>
  
        })} 
        <br />
            ضمیمه ها :<br/>
            {pageState.data.messageAttachements.map((v) => {
              return <span> <a href={"/Inbox/Download/" + v.guid} download={v.realName} >{v.realName}</a>
                   <br />
               </span>
            })}
            <br />
            متن:<br />
            <span dangerouslySetInnerHTML={{__html:pageState.data.context }}></span>
            <center>
                {pageState.data.isOwedYou == false &&
                    <Link to={"/Admin/NewMessage/" + id}><SimpleButton title="پاسخ"></SimpleButton></Link>
                }
            <SimpleButton title="بازگشت" onClick={() => { new Helper().GoBack(); }}></SimpleButton>
            </center>

        </FormDiv>
     </FromBasic>



}



export function InBoxApp() {
    let routes = [
        <Route path="NewMessage" element={<SendMessage />} />,
        <Route path="UnReadedMessages" element={<MessageList type={listType.inbox} unread={1}  />} />,
        <Route path="NewMessage/:id" element={<SendMessage />} />,
        <Route path="Inbox" element={<MessageList type={listType.inbox} key="1" />} />,
        <Route path="Outbox" element={<MessageList type={listType.outbox} key="2" />} />,
        <Route path="Message/:id" element={<ReadMessage />} />


    ]


    return routes;
}
